import React from "react";
import { Helmet } from "react-helmet-async";

/**
 * Injects a JSON-LD schema.org script tag via Helmet.
 */
export const JsonLd = ({ data }) => (
  <Helmet>
    <script type="application/ld+json">{JSON.stringify(data)}</script>
  </Helmet>
);

const BASE_URL = "https://quebecsecurity.services";

export const organizationSchema = () => ({
  "@context": "https://schema.org",
  "@type": "SecurityService",
  name: "Quebec Security Services",
  url: BASE_URL,
  logo: `${BASE_URL}/logo.png`,
  description: "BSP-licensed bilingual security guard services across Quebec — static guards, mobile patrol, mining, event, executive protection and more.",
  areaServed: {
    "@type": "AdministrativeArea",
    name: "Quebec",
  },
  serviceType: [
    "Static Guard Services",
    "Mobile Patrol",
    "Mining Site Security",
    "Event Security",
    "Executive Protection",
    "Construction Site Security",
    "Corporate Security",
    "Residential Security",
    "Alarm Response",
    "K9 Detection",
  ],
  address: {
    "@type": "PostalAddress",
    addressRegion: "Quebec",
    addressCountry: "CA",
  },
  sameAs: [
    "https://www.linkedin.com/company/quebec-security-services",
  ],
});

export const serviceSchema = (s) => ({
  "@context": "https://schema.org",
  "@type": "Service",
  name: s.name_en,
  serviceType: s.name_en,
  description: s.short_en,
  provider: {
    "@type": "SecurityService",
    name: "Quebec Security Services",
    url: BASE_URL,
  },
  areaServed: { "@type": "AdministrativeArea", name: "Quebec" },
  url: `${BASE_URL}/services/${s.slug}`,
  image: s.image,
});

export const citySchema = (c) => ({
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "@id": `${BASE_URL}/cities/${c.slug}`,
  name: `Quebec Security Services — ${c.name}`,
  url: `${BASE_URL}/cities/${c.slug}`,
  description: c.meta_description,
  areaServed: {
    "@type": "City",
    name: c.name,
    containedInPlace: { "@type": "AdministrativeArea", name: "Quebec, Canada" },
  },
  address: {
    "@type": "PostalAddress",
    addressLocality: c.name,
    addressRegion: c.region,
    addressCountry: "CA",
  },
  priceRange: "$$-$$$$",
});

export const articleSchema = (post) => ({
  "@context": "https://schema.org",
  "@type": "Article",
  headline: post.title,
  description: post.excerpt,
  image: post.image,
  datePublished: post.published,
  dateModified: post.published,
  author: {
    "@type": "Person",
    name: post.author || "Quebec Security Services",
  },
  publisher: {
    "@type": "Organization",
    name: "Quebec Security Services",
    logo: { "@type": "ImageObject", url: `${BASE_URL}/logo.png` },
  },
  mainEntityOfPage: `${BASE_URL}/insights/${post.slug}`,
});

export const breadcrumbSchema = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((it, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: it.name,
    item: `${BASE_URL}${it.path}`,
  })),
});
